import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { StorageOffersResponse } from 'src/apis/storage/types';
import type { StorageLocationDetailsRequest } from 'src/apis/storage/use-storage-location-details';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  storageLocationDetails?: StorageLocationDetailsRequest;
};

type ExecuteOptions = {
  url: string;
};

export function useOptionalStorageLocationOffers({
  storageLocationDetails,
}: HookOptions) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) =>
      axios.request<StorageOffersResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageLocationDetails?.response) return;
    if (!storageLocationDetails.response.data._links.getAvailableStorageOffers)
      return;

    const href =
      storageLocationDetails.response.data._links.getAvailableStorageOffers
        .href;
    request.execute({ url: urlTemplate.parse(href).expand({}) });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageLocationDetails?.response]);

  if (!storageLocationDetails) return;

  if (
    storageLocationDetails.response &&
    !storageLocationDetails.response.data._links.getAvailableStorageOffers
  )
    return;

  return request;
}

export type StorageLocationOffersRequest = ReturnType<
  typeof useOptionalStorageLocationOffers
>;
